export enum InstallState {
	current,
	updateAvailable,
	updateIsReady,
	isUpdating
}
